"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.writeCookie = exports.readCookie = void 0;
/* eslint-env browser */
var cookie_config_1 = require("./cookie-config");
var USE_SECURE_COOKIES = cookie_config_1.cookieConfig.USE_SECURE_COOKIES, USE_LOCALSTORAGE = cookie_config_1.cookieConfig.USE_LOCALSTORAGE;
/**
 * @private
 */
function getExpiryDate(expiresInDays) {
    if (expiresInDays === void 0) { expiresInDays = 1; }
    var expireTimestamp = Date.now() + expiresInDays * 1000 * 60 * 60 * 24;
    return new Date(expireTimestamp);
}
/**
 * Read a cookie from localStorage or document.cookie.
 */
/* eslint function-paren-newline: 0 */
/* eslint max-len: [2, 130] */
function readCookie(key, useLocalStorage) {
    if (useLocalStorage === void 0) { useLocalStorage = USE_LOCALSTORAGE; }
    if (useLocalStorage) {
        var fromLocalStorage = localStorage.getItem(key) || "";
        if (fromLocalStorage) {
            return fromLocalStorage;
        }
    }
    var fromCookieStore = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*".concat(encodeURIComponent(key).replace(/[-.+*]/g, "\\$&"), "\\s*\\=\\s*([^;]*).*$)|^.*$")), "$1"));
    return fromCookieStore;
}
exports.readCookie = readCookie;
/**
 * Write a cookie to document.cookie and/or localStorage
 *
 * @param key The key for the cookie
 * @param value The value for the cookie
 * @param domain The domain for the cookie.  You might want to use `getRootDomain()`
 *   for this to set the cookie at the "best" domain.
 * @param expiresInDays The number of days until the cookie should expire.  Defaults to 1.
 * @param useLocalStorage Whether to use localStorage *in addition* to setting a cookie.
 *   Note that localStorage has the specific origin of the current window.location, so
 *   if you set `domain` to something more general, then other subdomains will not be able
 *   to read back from the same localStorage, but will be able to read back the cookie only.
 * @param useSecureCookies Whether to write that have SameSite=None and Secure set.  You usually want this.
 */
function writeCookie(key, value, domain, expiresInDays, useLocalStorage, useSecureCookies) {
    if (expiresInDays === void 0) { expiresInDays = 1; }
    if (useLocalStorage === void 0) { useLocalStorage = USE_LOCALSTORAGE; }
    if (useSecureCookies === void 0) { useSecureCookies = USE_SECURE_COOKIES; }
    var expires = getExpiryDate(expiresInDays).toUTCString();
    var cookieString = "";
    cookieString = "".concat(key, "=").concat(encodeURIComponent(value));
    cookieString += ";path=/";
    if (domain) {
        cookieString += ";domain=".concat(domain);
    }
    if (expiresInDays) {
        cookieString += ";expires=".concat(expires);
    }
    if (useSecureCookies &&
        window.location.protocol === "https:" &&
        // 20200303
        // This only detects safari on desktop
        // (already fixed)
        // https://bugs.webkit.org/show_bug.cgi?id=198181
        // TODO: Remove this when market share with this
        // bug is low.. maybe 2020-08-ish.
        window.safari === undefined) {
        cookieString += ";SameSite=None;Secure";
    }
    document.cookie = cookieString;
    if (useLocalStorage) {
        if (value === "") {
            localStorage.removeItem(key);
        }
        else {
            localStorage.setItem(key, value);
        }
    }
}
exports.writeCookie = writeCookie;
/**
 * Delete a cookie
 */
function deleteCookie(key, domain) {
    writeCookie(key, "", domain, -1);
}
exports.deleteCookie = deleteCookie;
//# sourceMappingURL=cookie.js.map